// check all the roles are available or not
var containsAllRoles = (rolesWeWantToCheck, rolesUserHave) => {
    return rolesWeWantToCheck?.every((i) => rolesUserHave?.includes(i?.toLowerCase()));
};

function convertPrice(value) {
    return (value / 100).toFixed(2);
}
export {containsAllRoles, convertPrice}